import React, {useEffect} from "react";
import { FaCoffee, FaLeaf } from "react-icons/fa";  
import { MdFastfood, MdSoupKitchen } from "react-icons/md";  
import { GiNoodles, GiRiceCooker, GiMeal} from "react-icons/gi";  
import { TbBread} from "react-icons/tb";  
import '../styles/Restaurant.css';

const menu = [
    { title : 'Hot Drinks', 
     icon: <FaCoffee />,
     item : {
      'Tea' : 30,
      'Black Tea' : 20,
      'Black Ginger Tea' : 30,
      'Black Coffee' : 40,
      'Coffee' : 50,
      'Milk' : 60}
    },
   { title : 'Snacks',
    icon: <MdFastfood/>,
    item : {
      'Dry Chilli Paneer' : 250,
      'Chilli Mushroom Dry' : 240,
      'French Fries' : 150,
      'Pakoda' : 200,
      'Sandwich' : 120,
      'Butter Toast' : 80,
    }},
   { title : 'Chinese',
    icon: <GiNoodles/>,
    item : {
      'Veg Noodles' : 120,
      'Chilli Paneer Gravy' : 270,
      'Veg Maggie' : 70,
      'Plain Maggie' : 60,
      'Veg Momos' : 100,
      'Paneer Momos' : 150,
      'Manchooriyan' : 200,
      'Spring Rolls' : 120,
      'Veg Soup' : 60,
    }},
   { title : 'Roti & Paratha',
    icon: <TbBread/>,
    item : {
      'Tawa Roti' : 20,
      'Butter Roti' : 35,
      'Aloo Paratha' : 70,
      'Onion Paratha' : 80,
      'Paneer Paratha' : 100,
      'Mix Paratha' : 100,
    }},
   { title : 'Paneer & Veg',
    icon: <FaLeaf/>,
    item : {
      'Kadhai Paneer' : 280,
      'Shahi Paneer' : 270,
      'Matar Paneer' : 260,
      'Paneer Do Pyaza' : 280,
      'Dam Aloo' : 180,
      'Aloo Gobhi' : 150,
      'Aloo Zeera' : 140,
      'Mix Veg' : 220,
      'Aloo Matar' : 150,
    }},
   { title : 'Rice',
    icon: <GiRiceCooker/>,
    item : {
      'Plain Rice' : 110,
      'Zeera Rice' : 130,
      'Veg Biryani' : 200,
      'Matar Pulao' : 150,
      'Masala Rice' : 150,
      'Khichdi' : 150,
    }},
   { title : 'Dal',
    icon: <MdSoupKitchen/>,
    item : {
      'Dal Tadka' : 210,
      'Dal Makhani' : 260,
      'Rajma Masala' : 170,
      'Dal Yellow Tadka' : 200,
    }},
   { title : 'Thali',
    icon: <GiMeal/>,
    item : {
      'Veg Thali [4 Tawa Roti, 1 Mix Veg, Dal Makhani, Salad]' : 250,
      'Veg Delux Thali [4 Tawa Roti, Rice, Dal Makhani, Paneer, Salad, Gulab Jamun]' : 350,
    }},
]

const Restaurant = () => {
  useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);

  return (
    <div className="restaurant" id="restaurant">
    <h2>Restaurant Menu</h2>
    <p>
      Enjoy delicious local and Indian cuisine at our in-house restaurant!
      We serve breakfast, lunch, and dinner. Open daily from 7:00 AM to 10:00 PM.
    </p>
    <div className="menu-container">
      {menu.map((category, index) => (
        <div key={index} className="menu-category">
          <h3>{category.title} {category.icon}</h3>
          <ul>
            {Object.entries(category.item).map(([name, price]) => (
              <li key={name}>
                <span className="dish-name">{name}</span>
                <span className="dish-price">₹{price}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </div>
  );
};

export default Restaurant;
